/**
 * S10 · Industries (#industries) — THE FEED homepage, design.md Part III;
 * FINAL-SPEC §4 S10. The crossed hashtag tapes loop (CSS, only while .live);
 * this wires the pause control required by WCAG 2.2.2: aria-pressed="true"
 * means paused, and the choice holds for the rest of the visit.
 */
export function init(): void {
  const tapes = document.querySelector<HTMLElement>("#industries .ind-tapes");
  const toggle = tapes?.querySelector<HTMLButtonElement>(".ind-toggle");
  if (!tapes || !toggle) return;
  toggle.addEventListener("click", () => {
    const paused = toggle.getAttribute("aria-pressed") !== "true";
    toggle.setAttribute("aria-pressed", String(paused));
    tapes.classList.toggle("is-paused", paused);
  });
}
